"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleClassName = void 0;
const handleClassName = (variant, className) => `icon-ri icon-default
    ${(["filled", "full"].includes(variant) && "icon-filled") || ""}
    ${(["outlined", "full"].includes(variant) && "icon-outlined") || ""}
    ${className}`
    .trim()
    .replace(/\s{2,}/g, " ");
exports.handleClassName = handleClassName;
